// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-rules-page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  max-width: 850px;
  margin: 0 auto;
}

.game-rules-page-logo {
  display: block;
  object-fit: contain;
  max-width: 600px;
  margin-bottom: 32px !important;
  margin-top: 32px !important;
  margin: 0 auto;
}

.game-rules-page-header {
  color: #002129;
  text-align: center;
  font-weight: 700 !important;
  margin-bottom: 32px !important;
}
@media screen and (max-width: 900px) {
  .game-rules-page-header {
    font-size: 24px !important;
  }
}

.game-rules-page-navigation {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
}

.game-rules-page-tab {
  display: block;
  padding: 12px 8px;
  border-radius: 6px;
  color: #002129 !important;
  font-size: 18px !important;
  font-weight: 700 !important;
  cursor: pointer;
  white-space: nowrap;
  flex: 1 1;
  text-align: center;
}
.game-rules-page-tab.active {
  background-color: #E8E8E8;
}
@media screen and (max-width: 900px) {
  .game-rules-page-tab {
    font-size: 12px !important;
  }
}

@media (max-width: 600px) {
  .game-rules-page-container {
    padding: 16px;
  }
  .game-rules-page-logo {
    display: block;
    margin-bottom: 24px;
    max-width: 90%;
    margin: 0 auto;
  }
  .game-rules-page-header {
    font-size: 24px;
    margin-bottom: 24px;
  }
  .game-rules-page-tab {
    font-size: 12px;
  }
}
.game-rules-page-content-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-width: 311px;
  max-width: 800px;
  margin: 0 auto;
}
@media (max-width: 900px) {
  .game-rules-page-content-container {
    padding: 0 16px;
  }
}

.game-rules-page-content-header {
  font-size: 24px !important;
  font-weight: 700 !important;
  text-decoration: underline !important;
  text-align: center;
  margin-bottom: 16px !important;
  margin-top: 32px !important;
}
@media (max-width: 900px) {
  .game-rules-page-content-header {
    font-size: 12px !important;
  }
}

.game-rules-page-content-text {
  font-size: 16px !important;
  margin-bottom: 16px !important;
  text-align: left;
  font-weight: 500 !important;
}
@media (max-width: 900px) {
  .game-rules-page-content-text {
    font-size: 12px !important;
  }
}
.game-rules-page-content-text.bold {
  font-weight: 700 !important;
  margin-bottom: 0px !important;
}
.game-rules-page-content-text.centered {
  text-align: center;
}

.rules-page-prizes-container {
  text-align: center;
}

.rules-page-prizes-header {
  color: #002129;
  text-align: center;
  font-size: 20px !important;
  font-weight: 800 !important;
  text-decoration: underline;
  margin: 0;
  margin-bottom: 16px !important;
}
@media (max-width: 900px) {
  .rules-page-prizes-header {
    font-size: 16px !important;
    font-weight: 700 !important;
    margin: 0 auto;
  }
}

.rules-page-prizes-text {
  color: #002129;
  text-align: center;
  font-size: 18px !important;
  font-weight: 500 !important;
  margin-bottom: 20px !important;
}
@media (max-width: 900px) {
  .rules-page-prizes-text {
    font-size: 12px !important;
    margin-bottom: 10px !important;
  }
}

.rules-prize-text {
  display: flex;
  justify-content: center;
  align-items: center;
}

.rules-page-prizes-text .rules-highlight {
  font-weight: 700 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/GameRulesPage/GameRulesPage.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,2BAAA;EACA,cAAA;AACJ;;AAEA;EACI,cAAA;EACA,kBAAA;EACA,2BAAA;EACA,8BAAA;AACJ;AACI;EANJ;IAOQ,0BAAA;EAEN;AACF;;AACA;EACI,aAAA;EACA,6BAAA;EACA,WAAA;AAEJ;;AACA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAEJ;AAAI;EACI,yBAAA;AAER;AACI;EAhBJ;IAiBQ,0BAAA;EAEN;AACF;;AAEA;EACI;IACI,aAAA;EACN;EAEE;IACI,cAAA;IACA,mBAAA;IACA,cAAA;IACA,cAAA;EAAN;EAGE;IACI,eAAA;IACA,mBAAA;EADN;EAIE;IACI,eAAA;EAFN;AACF;AAKA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAHJ;AAKI;EATJ;IAUQ,eAAA;EAFN;AACF;;AAMA;EACI,0BAAA;EAEA,2BAAA;EACA,qCAAA;EACA,kBAAA;EACA,8BAAA;EACA,2BAAA;AAHJ;AAKI;EATJ;IAUQ,0BAAA;EAFN;AACF;;AAMA;EACI,0BAAA;EACA,8BAAA;EACA,gBAAA;EACA,2BAAA;AAHJ;AAKI;EANJ;IAOQ,0BAAA;EAFN;AACF;AAII;EACI,2BAAA;EACA,6BAAA;AAFR;AAKI;EACI,kBAAA;AAHR;;AAaC;EACG,kBAAA;AAVJ;;AAcE;EACE,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,SAAA;EACA,8BAAA;AAXJ;AAaI;EATF;IAUI,0BAAA;IACA,2BAAA;IACA,cAAA;EAVJ;AACF;;AAcE;EACE,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;AAXJ;AAaI;EAPF;IAQI,0BAAA;IACA,8BAAA;EAVJ;AACF;;AAcE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAXJ;;AAeE;EACE,2BAAA;AAZJ","sourcesContent":[".game-rules-page-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 32px;\n    max-width: 850px;\n    margin: 0 auto;\n}\n\n.game-rules-page-logo {\n    display: block;\n    object-fit: contain;\n    max-width: 600px;\n    margin-bottom: 32px !important;\n    margin-top: 32px !important;\n    margin: 0 auto;\n}\n\n.game-rules-page-header {\n    color: #002129;\n    text-align: center;\n    font-weight: 700 !important;\n    margin-bottom: 32px !important;\n\n    @media screen and (max-width: 900px) {\n        font-size: 24px !important;\n    }\n}\n\n.game-rules-page-navigation {\n    display: flex;\n    justify-content: space-evenly;\n    width: 100%;\n}\n\n.game-rules-page-tab {\n    display: block;\n    padding: 12px 8px;\n    border-radius: 6px;\n    color: #002129 !important;\n    font-size: 18px !important;\n    font-weight: 700 !important;\n    cursor: pointer;\n    white-space: nowrap;\n    flex: 1;\n    text-align: center;\n\n    &.active {\n        background-color: #E8E8E8;\n    }\n\n    @media screen and (max-width: 900px) {\n        font-size: 12px !important;\n        \n    }\n}\n\n@media (max-width: 600px) {\n    .game-rules-page-container {\n        padding: 16px;\n    }\n\n    .game-rules-page-logo {\n        display: block;\n        margin-bottom: 24px;\n        max-width: 90%;\n        margin: 0 auto;\n    }\n\n    .game-rules-page-header {\n        font-size: 24px;\n        margin-bottom: 24px;\n    }\n\n    .game-rules-page-tab {\n        font-size: 12px;\n    }\n}\n\n.game-rules-page-content-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    min-width: 311px;\n    max-width: 800px;\n    margin: 0 auto;\n\n    @media (max-width: 900px) {\n        padding: 0 16px;\n    }\n}\n\n\n.game-rules-page-content-header {\n    font-size: 24px !important;\n    margin-bottom: 16px;\n    font-weight: 700 !important;\n    text-decoration: underline !important;\n    text-align: center;\n    margin-bottom: 16px !important;\n    margin-top: 32px !important;\n\n    @media (max-width: 900px) {\n        font-size: 12px !important;\n\n    }\n}\n\n.game-rules-page-content-text {\n    font-size: 16px !important;\n    margin-bottom: 16px !important;\n    text-align: left;\n    font-weight: 500 !important;\n\n    @media (max-width: 900px) {\n        font-size: 12px !important;\n    }\n\n    &.bold {\n        font-weight: 700 !important;\n        margin-bottom: 0px !important;\n    }\n\n    &.centered {\n        text-align: center;\n    }\n}\n\n\n\n\n\n\n // Styling for the container Box\n .rules-page-prizes-container {\n    text-align: center; // Center align content\n  }\n  \n  // Styling for the header\n  .rules-page-prizes-header {\n    color: #002129;\n    text-align: center;\n    font-size: 20px !important; // Default size\n    font-weight: 800 !important; // Default weight\n    text-decoration: underline;\n    margin: 0;\n    margin-bottom: 16px !important;\n  \n    @media (max-width: 900px) { // Adjust to your mobile breakpoint\n      font-size: 16px !important; // Reduced size for mobile\n      font-weight: 700 !important;\n      margin: 0 auto;\n    }\n  }\n  \n  // Styling for the prize text\n  .rules-page-prizes-text {\n    color: #002129;\n    text-align: center;\n    font-size: 18px !important; // Default size\n    font-weight: 500 !important; // Default weight\n    margin-bottom: 20px !important; // Default margin\n  \n    @media (max-width: 900px) { // Adjust to your mobile breakpoint\n      font-size: 12px !important;\n      margin-bottom: 10px !important; // Reduced margin for mobile\n    }\n  }\n  \n  // Ensure text within .home-page-prizes-text is on the same line\n  .rules-prize-text {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  // Highlight style\n  .rules-page-prizes-text .rules-highlight {\n    font-weight: 700 !important;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
